import { render, staticRenderFns } from "./v-image-group.vue?vue&type=template&id=a5f421d2&scoped=true&"
import script from "./v-image-group.vue?vue&type=script&lang=js&"
export * from "./v-image-group.vue?vue&type=script&lang=js&"
import style0 from "./v-image-group.vue?vue&type=style&index=0&id=a5f421d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f421d2",
  null
  
)

export default component.exports